import Forward from "@/views/Forward.vue";

export default (rootPath) => {
  return [
    {
      path: "",
      component: Forward,
      redirect: `${rootPath}/list`,
      hidden: true,
      children: [
        {
          path: "list",
          component: () => import("@/views/table/EventsTable.vue"),
          meta: { title: "Список событий", activeMenuParent: true },
          hidden: true,
        },
        {
          path: "create",
          component: () => import("@/views/forms/EventsForm.vue"),
          meta: { title: "Создать событие", activeMenuParent: true },
          hidden: true,
        },
        {
          path: "edit/:id",
          component: () => import("@/views/forms/EventsForm.vue"),
          meta: { title: "Редактировать событие", activeMenuParent: true },
          hidden: true,
        },
      ],
    },
  ];
};
